
export class PayrollUser {
    id: number;
    userName: string;
}
